import moment from "moment";

import template from "./pClientExplorer.html";
import { Notes as NotesComponent } from '../Notes/Notes';
import { isEqual } from "lodash";

export function pClientExplorerDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pClientExplorerController,
    controllerAs: 'pClientExplorer',
    bindToController: true
  };

  return directive;
}

class pClientExplorerController {
  constructor ($scope, $location, $routeParams, $q, $window, Auth, Work, Notes, $interval, $translate, bModal, StopWatch, Bundle, $timeout, ConnectionQuality) {
    'ngInject';

    window.pClientExplorer = this;
    this.$timeout = $timeout;

    this.bModal = bModal;
    this.Bundle = Bundle;
    this.$location = $location;
    this.$scope = $scope;
    this.$routeParams = $routeParams;
    this.$q = $q;
    this.$window = $window;
    this.$translate = $translate;

    
    this.NotesComponent = NotesComponent;
    
    this.$scope.$watch(() => this.selectedClient, () => {
      if (this.user && this.selectedClient && this.selectedClient.name)
        this.selectedClientNameToDisplay = (this.selectedClient.additionalInfo ? "(" + this.selectedClient.additionalInfo + ") " : "") + this.selectedClient.name;
      else
      this.selectedClientNameToDisplay = '';
  });
  
    this.Auth = Auth;
    this.Notes = Notes;
    this.StopWatch = StopWatch;
    this.Work = Work;
    this.ConnectionQuality = ConnectionQuality;
    this.vacationBanner = false;
    this.state = "loading";
    this.shouldPasswordChange = false;
    this.klixVideoUrl = this.Bundle.getBundleType() !== 'roedl' ? 'https://cdn.klix-web.com/klix-intro.mp4' : 'https://cdn.klix-web.com/klix.mp4';
    this.klixVideoVisible = false;
    this.bpeVideoUrl = this.Bundle.getBundleType() !== 'roedl' ? 'https://cdn.klix-web.com/klix-intro.mp4' :'https://cdn.klix-web.com/bpe.mp4';
    this.bpeVideoVisible = false;
    this.newPassword = null;
    this.newPasswordConfirm = null;
    this.passwordChangeState = null; // 'done' || 'failed' || 'loading'
    this.validError = null;
    this.termsVisible = false;
    this.userPref = null;
    this.hasProjectsFlag = false;
    this.processGroupMappers = [];
    this.clients = [];
    this.currentTimeNotAvailableForNow = true;

    this.projects = [];
    this.internalProjects = [];
    this.selectedInternalProjectId = "";
    this.billingTypes = [];
    this.clientsWithNotes = null;

    this.multiSelectSettings = {
      displayProp: 'name',
      showCheckAll: false,
      showUncheckAll: false,
      smartButtonMaxItems: 4,
      checkBoxes: true,
      scrollableHeight: 'auto',
      scrollable: true,
      enableSearch: true,
      searchField: 'name'
    };

    this.dailyStats = {
      reportedTimeAsSeconds: 0,
      reportedTime: "PT0S",
      worknormAsSeconds: 1,
      cumulatedOvertime: "PT0S",
      todayOvertime: "PT0S"
    };

    this.$scope.$on('termsAccepted', () => {
      let newPreferences = angular.copy(this.userPref) || {};
      if(!this.userPref || !this.userPref.video) {
        this.klixVideoVisible = true;
        newPreferences.video = true;
        this.Auth.patchPreferences(newPreferences);
      }
    });

    this.notesProps = {
      text: '',
      readOnly: true,
      kill: false
    };
    this.notesAreEditable = false;

    this.timeout = $interval(() => {
      this.notes = Notes.getNotes();
    }, 10);

    $scope.$on("$destroy", () => {
      $interval.cancel( this.timeout );
      clearInterval(this.heartBeatInterval);
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });

    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        this.shouldPasswordChange = this.checkPasswordDate(moment(user.lastPasswordChange));

        this.getNotesInfoForClientsAndProcesses();

        this.Work.getJobCodeMappers().then(
          (success) => {
            if (success.data.processGroupMappers)
              this.processGroupMappers = success.data.processGroupMappers;
          },
          (err) => {
            this.error = err;
          }
        );

        this.Work.getCountryBillingTypes()
          .then(({ data: { billingTypes }}) =>
            this.billingTypes = Object.entries(billingTypes).reduce((accu, curr) => {
              accu.push({id: curr[0], name: curr[1]});
              return accu;
            }, [])
          );

        if (!this.$routeParams.clientId) {
          this.Auth.getMyPreferences(user).then(
            (preferences) => {
              this.userPref = preferences.data;

              // *Term of use* modal
              if (!this.user.acceptedLatestTermsOfUse) {
                this.Auth.getLatestTermsOfUse().then(
                  ({data}) => {
                    this.terms = {
                      ...data,
                      createdAt: moment(data.createdAt).format('DD-MM-YYYY')
                    };
                    this.termsVisible = true;
                  },
                  error => {
                    this.error = error;
                  }
                );
              } else {
                // *Video* modal
                let newPreferences = angular.copy(this.userPref) || {};
                if (!this.userPref || !this.userPref.video) {
                  this.klixVideoVisible = true;
                  newPreferences.video = true;
                  this.Auth.patchPreferences(newPreferences);
                }
              }
            },
            (error) => {
              this.error = error;
              this.Notes.postNote({type: "other", description: "WORK.ERRORS.PREFERENCES"});
            }
          );
        }

        this.Work.getDailyStats().then(
          (success) => {
            let reportedTime = moment.duration(success.data.reportedTime);
            let currentWorknorm = moment.duration(success.data.currentWorknorm);
            let cumulatedOvertime = moment.duration(success.data.cumulatedOvertime);
            let todayOvertime = reportedTime - currentWorknorm;
            this.dailyStats = {
              reportedTimeAsSeconds: reportedTime.asSeconds(),
              reportedTime: reportedTime.toJSON(),
              worknormAsSeconds: currentWorknorm.asSeconds(),
              cumulatedOvertime: cumulatedOvertime.toJSON(),
              todayOvertime: reportedTime > currentWorknorm ? moment.duration(todayOvertime).toJSON() : "PT0S",
              positionType: success.data.positionType
            };
          },
          (error) => {
            this.error = error;
            this.Notes.postNote({type: "other", description: "WORK.ERRORS.DAILY_STATS"});
          }
        );

        if (!this.user.preferences || !this.user.preferences.featureFlags) {
          this.Auth.setFeatureFlagsToLocaleStorage(this.user).then( newUserInfo => {
            this.user = newUserInfo;
            this.interruptsOnClientView = !!this.user.preferences.featureFlags.find(f => f == "InterruptsOnClientView");
            this.vacationReportingFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "VacationReporting");
            this.partDayVacationFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "PartTimeVacation");
            this.ProgressBarFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "ProgressBar");
            this.timerFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "Timer");
            this.invoiceDetailsFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "InvoiceDetails");
            this.hasProjectsFlag = this.user.preferences.featureFlags.find(f => f == "ProjectsSetManually" || f == "ProjectsFromErpSystem");
            this.interactiveNotesFeatureFlag = this.user.preferences.featureFlags.some(ff => ff === "InteractiveNotes");
          });
        } else {
          this.interruptsOnClientView = !!this.user.preferences.featureFlags.find(f => f == "InterruptsOnClientView");
          this.vacationReportingFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "VacationReporting");
          this.partDayVacationFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "PartTimeVacation");
          this.ProgressBarFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "ProgressBar");
          this.timerFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "Timer");
          this.invoiceDetailsFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "InvoiceDetails");
          this.hasProjectsFlag = this.user.preferences.featureFlags.find(f => f == "ProjectsSetManually" || f == "ProjectsFromErpSystem");
          this.interactiveNotesFeatureFlag = this.user.preferences.featureFlags.some(ff => ff === "InteractiveNotes");
        }


        this.Work.reportStateChange("ce-workspace-loading", this.user);

        Work.getWorkspace().then((workspaceData) => {
          this.Work.reportStateChange("ce-workspace-preparing", this.user);

          var workspace = workspaceData.data;
          this.isVacation = workspace.isOnVacation;
          this.workspace = workspace;
          this.clients = this.clientDeserialize(workspace);
          this.interrupts = workspace.interrupts;
          this.serviceLines = workspace.serviceLines;

          this.selectedInternalProject = this.clients.filter( (x) => x.name === "Internal")[0];
          this.internalProjects = this.selectedInternalProject ? this.selectedInternalProject.projects : [];
          this.hasProjectsFlag = this.internalProjects.length > 0 && this.hasProjectsFlag;

          this.someClientsVisible = true;

          if($routeParams.clientId) {
            this.clients
              .filter(({id}) => $routeParams.clientId == id)
              .map((x) => this.openClient(x));
          }
          this.state = "loaded";

          const startTime = angular.fromJson(localStorage.getItem("roedl-time-started")) ||  moment().toDate().getTime();
          const theresASavedProcess = localStorage.getItem("roedl-time-started");
          const theresASavedInterrupt = localStorage.getItem("roedl-time-started-interruption");
          const processIsOverdue = this.Work.processIsOverdue(moment.unix(startTime/1000));
          const processIsLostAskIfWeWantToContinue = this.Work.processIsLostAskIfWeWantToContinue();

          if(theresASavedProcess && (processIsOverdue || !processIsLostAskIfWeWantToContinue)) {
            this.Work.removeAnyTraceOfTheSavedProcess();
            if(processIsOverdue) this.Work.reportStateChange("ce-overdue-cleanup", this.user);
          } else if(theresASavedProcess && processIsLostAskIfWeWantToContinue) {
            this.askIfUserWantsToContinue();
          }


          if(!workspace.clients || !(workspace.clients.length > 0)) {
            this.Work.fireAndForgetMetric({type: "ERROR_WORKSPACE_EMPTY", email: this.user.emailAddress});
          }
          this.Work.reportStateChange("ce-workspace-loaded", this.user);

          if(!theresASavedProcess && theresASavedInterrupt){
            this.askIfUserWantsToContinueInterruption();
          }
        }, (error) => {
          this.Work.fireAndForgetMetric({type: "ERROR_WORKSPACE_NOT_LOADING", email: this.user.emailAddress});
          this.error = error;
          this.state = "error";
        });
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  getNotesInfoForClientsAndProcesses(updateCache) {
    this.Work.getNotesInfoForClientsAndProcesses(updateCache).then(
      ({ data }) =>
        this.clientsWithNotes = new Set(data.clients)
      , (err) => this.error = err
    );
  }

  checkPasswordDate(momentDate) {
    const momentAfterYear = momentDate.clone().add(1, 'y');
    return moment().isAfter(momentAfterYear);
  }

  setNewPassword() {
    this.error = null;
    this.passwordChangeState = 'loading';
    this.validError = this.Auth.validatePassword(this.newPassword, this.user.fullName);

    if(this.validError.isValid) {
      this.Auth.resetPassword(this.newPassword).then(
        ({data}) => {
          this.Auth.setupLogin(data);
          this.shouldPasswordChange = false;
          this.passwordChangeState = 'done';
        },
        (error) => {
          this.passwordChangeState = 'failed';
          this.error = error;
        }
      );
    } else {
      this.passwordChangeState = 'failed';
    }
  }

  askIfUserWantsToContinueInterruption(){
    this.modalConfig = {
      text: "WORK.RESUME_QUESTION",
      cancelText: "WORK.EXIT",
      acceptText: "WORK.RESUME_INTERRUPTION"
    };
    this.bModal.show(this.modalConfig).then(
      () => {
        var interruption = angular.fromJson(localStorage.getItem("roedl-time-started-interruption"));
        this.currentInterruption = this.workspace.interrupts.filter(({id}) => id == interruption.interruption.id)[0];
        this.interruptionStartTime = interruption.time;
        this.checkFinishTimeAvailableForInterrupt();
        this.fixInterruption();
        this.Notes.postNote({type: "resume", description: this.currentInterruption.name, time: moment(this.interruptionStartTime).format("HH:mm")});

        this.counterInt = this.StopWatch.counters.interrupt;
        this.counterInt.start = moment(interruption.time);
        this.StopWatch.stopCounter(this.counterInt);
        this.StopWatch.startCounter(this.counterInt);
      }, () => {
        this.Work.removeAnyTraceOfTheSavedProcess();
      });
  }

  selectInterruptClient(client) {
    this.interruptorSelectedClient = client;
    this.projects = client.projects;
    if(this.projects.length > 0) { this.selectedProjectId = this.projects[0].id;}

    const multiselectKeywords = this.interruptorSelectedClient.multiselectKeywords && this.interruptorSelectedClient.multiselectKeywords.length > 0 && this.interruptorSelectedClient.multiselectKeywords.map(keyword => ({id: keyword, name: keyword}));

    if (!isEqual(multiselectKeywords, this.multiselectKeywords))
      this.selectedKeywords = [];
    this.multiselectKeywords = multiselectKeywords;
    if (this.interruptorSelectedClient.defaultBillingTypeId)
      this.billingTypeId = this.interruptorSelectedClient.defaultBillingTypeId;
    else
      this.billingTypeId = null;
  }

  askIfUserWantsToContinue(){
    this.modalConfig = {
      text: "WORK.RESUME_QUESTION",
      cancelText: "WORK.EXIT",
      acceptText: "WORK.RESUME_PROCESS"
    };
    this.bModal.show(this.modalConfig).then(
      () => {
        this.startWork({
          id: localStorage.getItem("roedl-time-started-client-id"),
          name: "previous-client"
        }, {
          id: localStorage.getItem("roedl-time-started-pg"),
          name: "resumed-process-group"
        });
    }, () => {
      this.Work.removeAnyTraceOfTheSavedProcess();
    });
  }

  clientDeserialize(workspace) {
    if (!workspace.processGroups || ! workspace.processes || !workspace.clients) {
      this.Notes.postNote({type: "other", description: "TERMS_OF_USE.ERROR"});
      return [];
    }

    var processGroupsLookup = {};
    workspace.processGroups.map((pg => processGroupsLookup[pg.id] = pg));

    var processesLookup = {};
    workspace.processes.map((x => processesLookup[x.id] = x)).filter(process => !process.isHidden);

    var clients = workspace.clients.map((client) => {
      var x = angular.copy(client);
      x.bookmarked = this.Work.isBookmarked(client.id);


      if(x.name == "Internal") {
        x.internal = true;
      }

      // Only for our URL selected client
      if(x.id == this.$routeParams.clientId) {
        var uniqeProcessGroups = {};

        workspace
          .processClientConfigurations
          .filter(({clientId}) => x.id == clientId)
          .map(({processId}) => processesLookup[processId])
          .filter(processLookup => processLookup != undefined )
          .map(({processGroupId}) => processGroupsLookup[processGroupId])
          .map((pg) => {uniqeProcessGroups[pg.id] = pg;});

        x.processGroups = Object.keys(uniqeProcessGroups)
          .map((key) => uniqeProcessGroups[key])
          .map((pg) => angular.extend({}, pg, {bookmarked: this.Work.isBookmarked(pg.id)}));

      }

      if (x.additionalInfo) {
        x.nameWithAdditionalInfo = `(${x.additionalInfo}) ${x.name}`;
      }

      return x;
    });

    var x =  clients.sort((a, b) => {
      if(a.internal) return -1;
      if(b.internal) return 1;
      return a.name.localeCompare(b.name);
    });
    return x;
  }

  slugify(string) {
    return "s-" + string.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
  }

  doClientSearch() {
    this.clients.map((client) => {
      client.hidden = !(!this.clientSearch || client.name.toLowerCase().indexOf(this.clientSearch.toLowerCase()) != -1);
    });
    this.someClientsVisible = this.clients.some((x) => !x.hidden);
  }

  bookmarkClient(client) {
    client.bookmarked = !client.bookmarked;
    if(!this.Work.isBookmarked(client.id)) {
      this.Work.bookmark(client.id, "Client");
    } else {
      this.Work.unbookmark(client.id);
    }
  }

  bookmarkProcessGroup(pg) {
    pg.bookmarked = !pg.bookmarked;
    if(!this.Work.isBookmarked(pg.id)) {
      this.Work.bookmark(pg.id, "ProcessGroup");
    } else {
      this.Work.unbookmark(pg.id);
    }
  }

  isOnFullDayVacation() {
    return (this.vacationReportingFeatureFlag && !this.partDayVacationFeatureFlag && this.isVacation);
  }

  isOnPartDayVacation() {
    return (this.vacationReportingFeatureFlag && this.partDayVacationFeatureFlag && this.isVacation);
  }

  openClient(client) {
    this.clientNote = null;

    if (this.interactiveNotesFeatureFlag)
      this.Work.getNoteLatestVersion({clientId: client.id})
        .then((success) => this.clientNote = success.data.content);
    this.vacationBanner = this.vacationReportingFeatureFlag && !this.partDayVacationFeatureFlag && this.isVacation;
    this.Work.reportStateChange("ce-client-selecting", this.user);
    this.selectedClient = client;
    this.$location.path(`/clients/${client.id}/${this.slugify(client.name)}`);
    // If client has only has one process group, than start it automatically
    if(this.selectedClient.processGroups && this.selectedClient.processGroups.length == 1) {
      this.startWork(this.selectedClient, this.selectedClient.processGroups[0]);
    }
  }

  closeClient() {
    this.Work.reportStateChange("ce-client-closing", this.user);
    this.selectedClient = undefined;
    this.$location.path("/clients/");
  }

  startWork(client, processGroup) {
    this.Work.reportStateChange("ce-start-work", this.user);
    this.$location.path(`/clients/${client.id}/${this.slugify(client.name)}/work/${processGroup.id}/${this.slugify(processGroup.name)}`);
  }

  handleInterruption(interruption) {
    this.state = "loading";
    this.Work.getTimeNow().then((momentTimeNow) => {
      this.state = "loaded";
      this.interruptionStartTime =  momentTimeNow.toDate().getTime();
      this.checkFinishTimeAvailableForInterrupt();
      this.currentInterruption = interruption;
      this.fixInterruption();
      localStorage.setItem("roedl-time-started-interruption", angular.toJson({time: this.interruptionStartTime, interruption: this.currentInterruption}));

      this.counterInt = this.StopWatch.counters.interrupt;
      this.counterInt.start = moment();
      this.StopWatch.startCounter(this.counterInt);
    },
    () => {
      this.state = "error";
    });
  }

  fixInterruption() {
    if (this.currentInterruption.hasClient && this.currentInterruption.hasServiceLine) {
      this.currentInterruption.choice = undefined;
    } else if(this.currentInterruption.hasClient) {
      this.currentInterruption.choice = "client";
    } else if(this.currentInterruption.hasServiceLine) {
      this.currentInterruption.choice = "serviceLine";
    } else {
      this.currentInterruption.choice = "none";
    }
  }

  clearSelections(){
    this.currentInterruption.choice = undefined;
    this.interruptorSelectedClient = undefined;
    this.selectedServiceLine = undefined;
  }

  cancelInterruption() {
    localStorage.removeItem("roedl-time-started-interruption");
    this.interruptorClientSearch = "";
    this.currentTimeNotAvailableForNow = true;
    this.comment = "";
    this.invoiceDetails = null;
    this.interruptorSelectedClient = undefined;
    this.selectedServiceLine = undefined;
    this.currentInterruption = undefined;
    this.valueAdded = false;
    this.selectedProjectId = "";
    this.selectedKeywords = [];
    this.billingTypeId = null;
    this.multiselectKeywords = null;
    this.changeFinishTimeDefaultValue = this.changeFinishTimeValue = this.changeFinishTime = this.minChangeFinishTimeValue = null;
    this.changeFinishTimeValueFormatError = false;
    this.changeFinishTimeValueMinError = false;
    this.changeFinishTimeValueMaxError = false;
    if (this.changeInvoicingTime) {
      this.changeInvoicingTime = false;
      this.changeInvoicingTimeValue = null;
      this.changeInvoicingTimeValueError = null;
    }

    this.StopWatch.stopAndclearCounter(this.counterInt);
  }

  reportInterruption() {
    this.postFinish();
  }

  postFinish(){
    if(this.state == "loading")
      return;

    this.state = "loading";

    this.Work.getTimeNow().then((momentTimeNow) => {
      let endTime = momentTimeNow;
      let offset;
      if (this.changeFinishTime) {
        const [newHours, newMinutes, newSeconds] = this.changeFinishTimeValue.split(':');
        const originalDate = new Date(momentTimeNow);
        originalDate.setHours(parseInt(newHours), parseInt(newMinutes), parseInt(newSeconds), 0);
        endTime = moment.parseZone(originalDate.toISOString(), ["YYYY-MM-DDTHH:mm:ss.SSSZ", "YYYY-MM-DDTHH:mm:ssZ"]);
        offset = moment.duration(momentTimeNow - endTime);
      }

      var timeNow = endTime.toDate().getTime();
      var finishedAt = moment(timeNow).format("HH:mm");
      var correlationId = "post-" + this.user.id + "-" + timeNow;

      var interupt = this.currentInterruption;
      const duration = this.changeInvoicingTime
        ? moment.duration(this.formatCounterToTime(this.counterInt), "HH:mm:ss")
        : "PT" + ((timeNow - this.interruptionStartTime) / 1000).toFixed(4) + "S";
      var worklog = {
          duration: duration,
          interruptId: this.currentInterruption.id,
          comment: this.comment,
          invoiceDetails: this.invoiceDetails,
          zoneId: this.user.timezone || moment.tz.guess(),
          startTimeCheck: this.interruptionStartTime,
          valueAdded: this.valueAdded
        };

      if (this.changeInvoicingTime)
        worklog.invoicedTime = moment.duration(this.changeInvoicingTimeValue);

      if (this.valueAdded)
        worklog.billingTypeId = this.billingTypeId;

      if (this.selectedKeywords && this.selectedKeywords.length > 0)
        worklog.clientMultiselectKeywords = this.selectedKeywords.map(keyword => keyword.name);

      if(worklog.interruptId !== null && this.hasProjectsFlag && !this.interruptorSelectedClient){
        worklog = {
          ...worklog,
          projectId : this.selectedInternalProjectId
        };
      }

      if(this.projects.length > 0 && this.interruptorSelectedClient) {worklog.projectId = this.selectedProjectId;}
      if(this.interruptorSelectedClient) { worklog.clientId = this.interruptorSelectedClient.id; }
      if(this.selectedServiceLine) { worklog.serviceLine = this.selectedServiceLine; }
      this.selectedProjectId = "";

      if (offset)
        worklog.offset = offset;

      //* DISCARDING OVERNIGHT PROCESSES*//
      if(this.Work.processIsOverdue(moment.unix(worklog.startTimeCheck/1000))){
        this.Notes.postNote({type: "error", description: "WORK.ERROR_PROCESS_TOO_LONG", correlationId: correlationId});

        this.Work.fireAndForgetMetric({
          type: "ERROR_PROCESS_TOO_LONG",
          email: this.user.emailAddress,
          timeNow: timeNow,
          interruptionStartTime: this.interruptionStartTime,
          finishedAt: finishedAt,
          interupt: interupt,
          worklog: worklog
        }, correlationId).then(angular.noop, angular.noop);
        this.state = "error";

      } else {
        this.Work.reportStateChange("process-posting", this.user, correlationId);
        this.Work.log(worklog, correlationId).then(() => {

          this.Work.reportStateChange("process-posted", this.user, correlationId);
          this.Notes.postNote({type: "interruption", description: interupt.name, time: finishedAt});

          this.StopWatch.stopAndclearCounter(this.counterInt);

          this.currentTimeNotAvailableForNow = true;

          this.interruptorSelectedClient = undefined;
          this.selectedServiceLine = undefined;
          this.interruptorClientSearch = "";
          this.comment = "";
          this.invoiceDetails = null;
          this.interruptionStartTime = undefined;
          this.currentInterruption = undefined;
          this.volume = 0;
          this.valueAdded = false;
          this.billingTypeId = null;
          this.selectedKeywords = null;
          this.multiselectKeywords = null;
          this.changeInvoicingTime = false;
          this.changeInvoicingTimeValue = null;
          this.changeInvoicingTimeValueError = null;

          localStorage.removeItem("roedl-time-started-interruption");

          this.endOnFinish = false;
          
          this.changeFinishTimeDefaultValue = this.changeFinishTimeValue = this.changeFinishTime = this.minChangeFinishTimeValue = null;

          this.state = "loaded";
        }, (error) => {
          this.Work.reportStateChange("process-posting-error", this.user, correlationId);
          this.Work.fireAndForgetMetric({
            type: "ERROR",
            email: this.user.emailAddress,
            timeNow: timeNow,
            interruptionStartTime: this.interruptionStartTime,
            finishedAt: finishedAt,
            interupt: interupt,
            worklog: worklog
          }, correlationId).then(angular.noop, angular.noop);
          this.Notes.postNote({type: "error", description: "WORK.ERROR_SENDING", error: error, correlationId: correlationId});
          this.state = "loaded";
        });
      }
    });
  }

  jobCodeDescription(objToMap) {
    const jobCode = this.processGroupMappers.find(pg => pg.interruptCountryConfigurationId === objToMap.id || pg.processGroupCountryConfigurationId === objToMap.id);

    if (!jobCode)
      return [];

    return ['CASEman JobCode: ', jobCode.jobCodeId + ' - ' + jobCode.jobCodeName];
  }

  getHeartbeat(clientId) {
    this.Work.getHeartbeat({clientId}).then(
      (success) => {
        this.notesAreEditable = success.data.canUserCreateNoteHeartbeat;
      }
    );
  }

  openClientNotePreviewModal() {
    this.notesModal = true;
    this.notesProps.text = this.clientNote;
    this.notesProps.preview = true;
  }

  openNotesModal(clientId) {
    const clientName = this.clients.find(client => client.id === clientId).name;
    this.Work.getNoteLatestVersion({clientId}).then(
      (success) => {
        this.notesModal = true;
        this.notesProps.clientId = clientId;
        this.notesProps.clientName = clientName;
        this.notesProps.text = (success.data && success.data.content) || '';
        const clientHasNote = this.clientsWithNotes.has(clientId);
        if (this.notesProps.text === '' && clientHasNote || this.notesProps.text !== '' && !clientHasNote)
          this.getNotesInfoForClientsAndProcesses(true);
        this.getHeartbeat(clientId);
        this.heartBeatInterval = setInterval(() => this.getHeartbeat(), 60 * 1000);
      },
      (error) => {
        this.Notes.postNote({ type: "noteError", description: "ERROR_LOADING_DATA", error: error });
        this.error = error;
      }
    );
  }

  openClientNotes(notesProps) {
    sessionStorage.setItem('notes-info', JSON.stringify({
      client: notesProps.name
    }));
    this.notesAreEditable = false;

    this.$window.open(this.$location.url() + `notes?clientId=${notesProps.clientId}`);
  }

  showOptions() {
    return this.notesProps.automation.join(', ');
  }

  closeNotesModal() {
    this.notesModal = null;
    this.notesProps = {
      ...this.notesProps,
      kill: true
    };

    this.$timeout(() => {
      this.notesProps = {
        text: '',
        readOnly: true
      };
      this.notesAreEditable = false;
      clearInterval(this.heartBeatInterval);
      this.heartBeatInterval = null;
    }, 500);
  }

  noteSaved() {
    this.getNotesInfoForClientsAndProcesses(true);
    this.closeNotesModal();
    this.Notes.postNote({ type: 'noteSaved', description: "Note saved" });
  }

  timeoutError() {
    this.closeNotesModal();
    this.Notes.postNote({ type: 'error', description: "Time for edition exceeded" });
  }

  notesPageError() {
    this.Notes.postNote({ type: "noteError", description: 'Someone is just editing a note.' });
  }

  notesPageClosed() {
    this.notesAreEditable = true;
  }

  showMainType(billingTypeId) {
    const reportingClient = this.interruptorSelectedClient;
    return reportingClient.defaultBillingTypeId === billingTypeId ? ' (MAIN TYPE)' : '';
  }

  selectAnotherClient() {
    this.interruptorSelectedClient = null;
    this.billingTypeId = null;
    this.selectedKeywords = null;
    this.multiselectKeywords = null;
  }

  handlerChangeInvoicingToFalse(counterType) {
    this.StopWatch.startCounter(this[counterType]);
    this.changeInvoicingTimeValue = null;
    this.changeInvoicingTimeValueError = null;
  }

  changeInterruptsInvoicingTimeHandler() {
    if (this.changeInvoicingTime) {
      this.StopWatch.stopCounter(this.counterInt);
      this.changeInvoicingTimeValue = this.formatCounterToTime(this.counterInt);
    }
    else {
      this.handlerChangeInvoicingToFalse('counterInt');
    }
  }

  validateInvoicingTime() {
    const hour = this.changeInvoicingTimeValue;

    if ((!hour || hour.length === 0) && this.changeInvoicingTimeValueError) {
      delete this.changeInvoicingTimeValueError;
      return;
    }

    clearTimeout(this.updateHoursFunction);
    this.updateHoursFunction = setTimeout(() => {

      const numberFormat = /^(\d*([,.]\d*)|\d*)$/;
      const format = /^(\d+:[0-5]\d:[0-5]\d|\d*([,.]\d*)|\d*)$/;
      const match = hour.match(format);

      if (!match) {
        this.changeInvoicingTimeValueError = this.$translate.instant("INVALID_TIME_FORMAT");
      }
      else {
        if (this.changeInvoicingTimeValueError)
          delete this.changeInvoicingTimeValueError;

        if (hour.match(numberFormat))
          this.changeInvoicingTimeValue = this.formatNumberToTime(hour);
      }
    }, 700);
  }

  formatCounterToTime(counter) {
    return `${this.StopWatch.pad0(counter.hours)}:${this.StopWatch.pad0(counter.minutes)}:${this.StopWatch.pad0(counter.seconds)}`;
  }

  changeFinishTimeDisabledTooltip() {
    if (!this.minChangeFinishTimeValue)
      return this.$translate.instant("WORK.LOADING_POSSIBLE_FINISH_TIME");
    else
      return this.$translate.instant("WORK.CHANGED_FINISH_TIME_DISABLED_TOOLTIP", { min: moment(this.minChangeFinishTimeValue).startOf('minutes').add(2, 'minutes').format("HH:mm:ss") });
  }

  checkFinishTimeAvailableForInterrupt() {
    this.minChangeFinishTimeValue = this.interruptionStartTime + 1000;
    const changeFinishTimeValue = moment().subtract(1, "minute").startOf('minute');
    const changeFinishTimeValueFormatted = changeFinishTimeValue.format("HH:mm:ss");
    const currentTimeNotAvailableForNow = moment(changeFinishTimeValueFormatted, "HH:mm:ss").isSameOrBefore(moment(this.minChangeFinishTimeValue), 'seconds');

    let intervalDuration;
    if (currentTimeNotAvailableForNow) {
      intervalDuration = moment(this.minChangeFinishTimeValue).startOf('minute').add(2, 'minute').valueOf() - new Date().valueOf();
    } else {
      intervalDuration = moment().startOf('minute').add(1, 'minute').valueOf() - new Date().valueOf();
    }

    clearInterval(this.checkInterruptsDuringProcessInterval);
    this.checkInterruptsDuringProcessInterval = setInterval(() => this.checkFinishTimeAvailableForInterrupt(), intervalDuration);
    this.currentTimeNotAvailableForNow = currentTimeNotAvailableForNow;
  }

  changeFinishTimeHandler() {
    if (this.changeFinishTime) {
      if (!this.changeFinishTimeDefaultValue) {
        this.changeFinishTimeDefaultValue = moment().subtract(1, "minute").startOf('minute');
        this.changeFinishTimeDefaultValueFormatted = this.changeFinishTimeDefaultValue.format("HH:mm:ss");
      }
      
      this.changeFinishTimeValue = this.changeFinishTimeDefaultValueFormatted;
    }
    else {
      this.changeFinishTimeValue = null;
      this.changeFinishTimeValueFormatError = false;
      this.changeFinishTimeValueMinError = false;
      this.changeFinishTimeValueMaxError = false;
      this.changeFinishTimeDefaultValue = null;
    }
  }

  formatNumberToTime(time) {
    const formattedHours = time.replaceAll(',', '.');
    const duration = moment.duration(formattedHours, 'hours');

    const timePart = (timePart) => {
      return timePart < 10 ? `0${timePart}` : timePart;
    };

    return `${timePart(duration.get('hours'))}:${timePart(duration.get('minutes'))}:${timePart(duration.get('seconds'))}`;
  }

  validateHour() {
    const hour = this.changeFinishTimeValue;

    if ((!hour || hour.length === 0) && this.changeFinishTimeValueFormatError) {
      delete this.changeFinishTimeValueFormatError;
      return;
    }

    clearTimeout(this.updateHoursFunction);
    this.updateHoursFunction = setTimeout(() => {
      if (!hour) {
        this.changeFinishTimeValueFormatError = true;
        return;
      }

      const numberFormat = /^(\d*([,.]\d*)|\d*)$/;
      const format = /^(\d+:[0-5]\d:[0-5]\d|\d*([,.]\d*)|\d*)$/;
      const match = hour.match(format);

      if (!match) {
        this.changeFinishTimeValueFormatError = true;
      }
      else {
        if (this.changeFinishTimeValueFormatError)
          delete this.changeFinishTimeValueFormatError;

        if (hour.match(numberFormat))
          this.changeFinishTimeValue = this.formatNumberToTime(hour);

        if (moment(hour, "HH:mm:ss").isBefore(moment(this.minChangeFinishTimeValue).startOf('second').add(1, 'second'), 'seconds'))
          this.changeFinishTimeValueMinError = true;
        else if (this.changeFinishTimeValueMinError)
          this.changeFinishTimeValueMinError = false;

        if (moment(hour, "HH:mm:ss").isAfter(moment(this.changeFinishTimeDefaultValueFormatted, "HH:mm:ss")))
          this.changeFinishTimeValueMaxError = true;
        else if (this.changeFinishTimeValueMaxError)
          this.changeFinishTimeValueMaxError = false;
      }
    }, 700);
  }

  timeValueToHour(value) {
      return moment(value).startOf('second').add(1, 'second').format("HH:mm:ss");
    }

  maximumOffsetTooltip() {
    return this.$translate.instant("WORK.MAXIMUM_PROCESS_OFFSET", {min: this.timeValueToHour(this.minChangeFinishTimeValue), max: this.changeFinishTimeDefaultValueFormatted});
  }
}
